import { render, staticRenderFns } from "./HolidayPage.vue?vue&type=template&id=51ad01c6&scoped=true&"
import script from "./HolidayPage.vue?vue&type=script&lang=js&"
export * from "./HolidayPage.vue?vue&type=script&lang=js&"
import style0 from "./HolidayPage.vue?vue&type=style&index=0&id=51ad01c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ad01c6",
  null
  
)

export default component.exports